export class FinanciacionPrivadaConst {
  public static headerTable = [
    { field: 'descripcion', title: 'Descripción', cell: (row) => row.descripcion ? `${row.descripcion}` : '', class: (row) => `` },
    { field: 'importeInicial', title: 'Importe inicial', cell: (row) => row.importeInicial ? `${row.importeInicial}` : '0.00', class: (row) => `` },
    { field: 'importePendiente', title: 'Importe pendiente', cell: (row) => row.importePendiente ? `${row.importePendiente}` : '0.00', class: (row) => `` },
    { field: 'fechaConstitucion', title: 'Fecha constitución', cell: (row) => `${new Date(row.fechaConstitucion).toLocaleDateString()}`, class: (row) => `` },
    { field: 'fechaFinalizacion', title: 'Fecha finalización', cell: (row) => `${new Date(row.fechaFinalizacion).toLocaleDateString()}`, class: (row) => `` },
  ];
}
